interface ServicesSectionProps {
  onWhatsAppClick: () => void;
}

export default function ServicesSection({ onWhatsAppClick }: ServicesSectionProps) {
  const services = [
    {
      icon: 'ri-heart-3-line',
      title: 'Casamentos',
      subtitle: 'Iluminação personalizada + som ambiente + pista animada',
      description: 'Som cristalino para cerimônia e festa, iluminação cênica romântica, DJ experiente em repertório para todas as idades, equipamentos de backup, mesa de som profissional, microfones sem fio para discursos.',
    },
    {
      icon: 'ri-cake-3-line',
      title: 'Aniversários',
      subtitle: 'Músicas variadas, interação, microfone e efeitos',
      description: 'Repertório diversificado do sertanejo ao funk, animação interativa com jogos e brincadeiras, efeitos especiais de luz e fumaça, karaokê opcional, decoração com luz ambiente personalizada.',
    },
    {
      icon: 'ri-sparkling-line',
      title: 'Debutantes',
      subtitle: 'Hits do momento, luzes, fogos indoor (opcional)',
      description: 'Playlist atualizada com hits do TikTok e rádio, coreografia para valsa, fogos indoor para momentos especiais, iluminação LED colorida, som potente para pista de dança, animação jovem.',
    },
    {
      icon: 'ri-building-line',
      title: 'Eventos Corporativos',
      subtitle: 'Confraternizações, encerramentos e eventos empresariais',
      description: 'Som ambiente profissional, microfones para apresentações, playlist adequada ao ambiente corporativo, iluminação discreta e elegante, equipamentos de alta qualidade, pontualidade garantida.',
    },
    {
      icon: 'ri-car-line',
      title: 'Carro de Propaganda',
      subtitle: 'Locução profissional e som potente para promoções',
      description: 'Sistema de som automotivo potente, locução ao vivo personalizada, roteiro criativo para sua campanha, cobertura estratégica da cidade, horários flexíveis, impacto garantido.',
    },
    {
      icon: 'ri-music-line',
      title: 'Festas em Geral',
      subtitle: 'Do pagode ao eletrônico, adaptado ao seu público',
      description: 'Repertório completo todos os estilos musicais, leitura de público especializada, equipamentos modulares conforme o espaço, iluminação ambiente e cênica, animação personalizada.',
    },
  ];

  return (
    <section id="servicos" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Serviços Oferecidos</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto"></div>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mb-4">
                <i className={`${service.icon} text-white text-lg`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h3>
              <p className="text-gray-600 font-medium mb-3 text-sm">{service.subtitle}</p>
              <p className="text-gray-500 text-xs mb-4 leading-relaxed">{service.description}</p>
              <button 
                onClick={onWhatsAppClick}
                className="w-full bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-full font-bold transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center text-sm"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                Falar com DJ Jean
              </button>
            </div>
          ))}
        </div>
        
        <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-6 rounded-2xl mt-10">
          <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">
            <i className="ri-add-circle-line mr-2 text-blue-600"></i>
            Extras Disponíveis
          </h3>
          <p className="text-gray-700 text-base mb-4 text-center">
            Zumba, som ambiente, entrega de troféus, inaugurações, e muito mais. Entre em contato para conhecer todos os nossos serviços adicionais!
          </p>
          <div className="text-center">
            <button 
              onClick={onWhatsAppClick}
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-full font-bold transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Falar com DJ Jean
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}